import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../components/Account/Login';
import Signup from '../components/Account/Signup';
import Provider from '../components/Account/Provider';
import ForgotPassword from '../components/Account/ForgotPassword';
import Account from '../components/Account/Account';
import EmailVerification from '../components/Account/EmailVerification';
import ResetPassword from '../components/Account/ResetPassword';
import EditPassword from '../components/Account/EditPassword';
import CommunityList from "@/components/Community/List";
import CommunityCreate from "@/components/Community/Create";
import CommunityDetail from "@/components/Community/Detail";
import CommunityEdit from "@/components/Community/Edit";
import EventList from '../components/Events/List';
import EventCreate from '../components/Events/Create';
import EventDetail from '../components/Events/Detail';
import EventEdit from '../components/Events/Edit';
import Privacy from '../components/Content/Privacy';
import Eula from '../components/Content/Eula';
import NotFound from '../components/NotFound';

import store from '../store';
import {COMMUNITY_REQUEST} from "@/store/constant";

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const ifHasCommunities = async function (to, from, next) {
  await store.dispatch(COMMUNITY_REQUEST);
  const communities = store.getters.communities;
  if (communities && communities.length !== 0) {
    next()
    return
  }
  next('/event')
}

Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: 'event', name: 'home' },
  { path: '/login', name: 'login', component: Login, beforeEnter: ifNotAuthenticated },
  { path: '/signup', name: 'signup', component: Signup, beforeEnter: ifNotAuthenticated },
  { path: '/forgot-password', name: 'forgot-password', component: ForgotPassword, beforeEnter: ifNotAuthenticated },
  { path: '/reset-password', name: 'reset-password', component: ResetPassword, beforeEnter: ifNotAuthenticated },
  { path: '/edit-password', name: 'edit-password', component: EditPassword, beforeEnter: ifAuthenticated },
  { path: '/email-verification', name: 'email-verification', component: EmailVerification, beforeEnter: ifNotAuthenticated },
  { path: '/provider-auth/:provider', name: 'provider-auth', component: Provider, beforeEnter: ifNotAuthenticated },
  { path: '/account', name: 'account', component: Account, beforeEnter: ifAuthenticated },
  { path: '/community', name: 'communities', component: CommunityList, beforeEnter: ifAuthenticated },
  { path: '/community/create', name: 'community-create', component: CommunityCreate, beforeEnter: ifAuthenticated },
  { path: '/community/:id', name: 'community-detail', component: CommunityDetail, beforeEnter: ifAuthenticated },
  { path: '/community/edit/:id', name: 'community-edit', component: CommunityEdit, beforeEnter: ifAuthenticated },
  { path: '/event', name: 'events', component: EventList, beforeEnter: ifAuthenticated },
  { path: '/event/create', name: 'event-create', component: EventCreate, beforeEnter: ifAuthenticated && ifHasCommunities },
  { path: '/event/:id', name: 'event-detail', component: EventDetail, beforeEnter: ifAuthenticated },
  { path: '/event/edit/:id', name: 'event-edit', component: EventEdit, beforeEnter: ifAuthenticated },
  { path: '/privacy-policy', name: 'privacy-policy', component: Privacy },
  { path: '/eula', name: 'eula', component: Eula },
  { name: 'not-found', abstract: true, path: '*', component: NotFound },
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
